export default class Event {
    private _callbacks: any[];

    constructor() {
        this._callbacks = [];
    }

    addHandler(cb: any) {
        this._callbacks.push(cb);
    }

    removeHandler(cb: any) {
        var idx = this._callbacks.findIndex(item => item === cb);
        if (idx >= 0) {
            this._callbacks.splice(idx, 1);
        }
    }

    raise(...params: any[]) {
        for (let i = 0; i < this._callbacks.length; i++) {
            this._callbacks[i](...params);
        }
    }
}